const BORDER_RADIUS = 'md';
const INPUT_BACKGROUND_COLOR = 'white';

export const inputTheme = {
    baseStyle: {
        field: {
            background: INPUT_BACKGROUND_COLOR,
            backgroundColor: INPUT_BACKGROUND_COLOR,
            borderRadius: BORDER_RADIUS,
            fontSize: 'sm',
        },
        control: {
            backgroundColor: INPUT_BACKGROUND_COLOR,
        },
        icon: {
            color: 'muted.100',
        },
        addon: {
            color: 'muted.100',
            borderRadius: BORDER_RADIUS,
        },
        background: INPUT_BACKGROUND_COLOR,
        backgroundColor: INPUT_BACKGROUND_COLOR,
    },
    defaultProps: {
        focusBorderColor: 'secondary.500',
    },
};

export const checkboxTheme = {
    baseStyle: {
        field: {
            background: INPUT_BACKGROUND_COLOR,
            backgroundColor: INPUT_BACKGROUND_COLOR,
            borderRadius: BORDER_RADIUS,
            fontSize: 'sm',
        },
        control: {
            backgroundColor: INPUT_BACKGROUND_COLOR,
        },
        icon: {
            color: 'charcoal.900',
        },
        addon: {
            color: 'muted.100',
            borderRadius: BORDER_RADIUS,
        },
        background: INPUT_BACKGROUND_COLOR,
        backgroundColor: INPUT_BACKGROUND_COLOR,
    },
    variants: {
        lite: {
            icon: {
                color: 'white.900',
            },
        },
    },
    defaultProps: {
        colorScheme: 'transparent',
        focusBorderColor: 'secondary.500',
    },
};
